/**
 * Rastreia o ciclo de ordenação de uma coluna de tabela e sinaliza quando o sort deve ser resetado.
 * No terceiro clique na mesma coluna (asc → desc → reset), retorna true.
 */
export class TableSortResetter {
  private lastField: string | undefined = undefined;
  private lastOrder: number = 0;

  /**
   * Retorna true quando o terceiro clique é detectado (mesmo campo voltando para asc após desc).
   * Atualiza o estado interno a cada chamada.
   */
  reset(incomingField: string | undefined, incomingOrder: number): boolean {
    if (incomingField && incomingField === this.lastField && incomingOrder === 1 && this.lastOrder === -1) {
      this.lastField = undefined;
      this.lastOrder = 0;
      return true;
    }
    this.lastField = incomingField;
    this.lastOrder = incomingOrder;
    return false;
  }
}
